const API_URL = process.env.REACT_APP_API_URL;

export const sendEmail = async (subject,html) => {
    const emailData = {
        subject,html

    };

    try {
        const response = await fetch(`${API_URL}/api/send-mail`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(emailData),
        });

        const result = await response.json();
        console.log("Kết quả:", result);
    } catch (error) {
        console.error("Lỗi khi gửi mail:", error);
        throw error
    }
};